import { CITY_DATA } from "./cityData";
import CoverPage from "./CoverPage";
import GlancePage from "./GlancePage";
import MonthlyPage from "./MonthlyPage";
import ExpectPage from "./ExpectPage";
import ServicePage from "./ServicePage";

const CONTACT = { name: "The Truestays team", email: "ollie@truestays.co.uk", phone: "", bookUrl: "truestays.co.uk" };
const OFFER = "Free onboarding (usually £150) when you request a valuation this month.";

export default function DetailedReport({ inputs, data, warmUp, refs }) {
  const host = inputs.hostName || "there";
  const address = inputs.address || "Your property";
  const cityName = inputs.locality || "your area";
  const bedrooms = inputs.bedrooms || "-";
  const guests = inputs.guests || "-";
  const baseRate = parseFloat(inputs.baseRate) || 0;
  const mgmtFeePct = parseFloat(inputs.commissionRate) || 0;
  const vatRatePct = parseFloat(inputs.vatRate) || 0;
  const platformFeePct = parseFloat(inputs.platformFee) || 0;

  // Rows in the same order the calculator already produces (starting at the selected start month)
  const rows = data.months.map((m) => ({
    month: m.month, days: m.days, occ: m.occ, nights: m.nights, adr: m.nightlyRate,
    gross: m.gross, mgmt: m.mgmtFee, vat: m.vat, plat: m.platFee, net: m.realNet,
  }));

  const T = {
    gross: data.totals.gross, mgmt: data.totals.mgmtFee, vat: data.totals.vat,
    plat: data.totals.platFee, net: data.totals.net, nights: data.totals.nights,
    adr: data.avgNightlyRate, occ: data.avgOcc,
  };
  T.netNight = T.nights > 0 ? T.net / T.nights : 0;
  T.avgMonth = T.net / 12;

  const byNet = [...rows].sort((a, b) => b.net - a.net);
  const peak = byNet[0] || { net: 0, month: "" };
  const quiet = byNet[byNet.length - 1] || { net: 0, month: "" };
  const peakMonths = rows.filter((r) => r.net === peak.net).map((r) => r.month);
  const summer = rows.filter((r) => ["Jun", "Jul", "Aug", "Sep"].includes(r.month)).reduce((s, r) => s + r.net, 0);

  const keepRate = 1 - (mgmtFeePct / 100 + platformFeePct / 100) * (1 + vatRatePct / 100);
  const scenario = (nf, af) => {
    let g = 0, n = 0;
    rows.forEach((r) => {
      const nn = Math.min(r.days, Math.round(r.nights * nf));
      n += nn;
      g += nn * Math.round(r.adr * af);
    });
    return { net: g * keepRate, occ: (n / 365) * 100, nights: n };
  };
  const low = scenario(0.88, 0.95);
  const high = scenario(1.08, 1.05);

  const now = new Date();
  const dateStr = now.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
  const validTo = new Date(now.getTime() + 30 * 864e5).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
  const initials = host.split(/\s+/).map((w) => w[0] || "").join("").toUpperCase();
  const ref = `TS-${(cityName || "UK").slice(0, 3).toUpperCase()}-${now.toISOString().slice(2, 10).replace(/-/g, "")}-${initials}`;

  const city = CITY_DATA[cityName] || CITY_DATA._default;

  return (
    <div style={{ position: "fixed", top: 0, left: -99999, zIndex: -1 }}>
      <CoverPage pageRef={refs.cover} host={host} address={address} cityName={cityName} bedrooms={bedrooms} guests={guests} netTotal={T.net} avgMonth={T.avgMonth} dateStr={dateStr} refCode={ref} />
      <GlancePage pageRef={refs.glance} host={host} address={address} cityName={cityName} bedrooms={bedrooms} T={T} peak={peak} peakMonths={peakMonths} quiet={quiet} summer={summer} />
      <MonthlyPage pageRef={refs.monthly} host={host} address={address} cityName={cityName} rows={rows} T={T} peak={peak} peakMonths={peakMonths} quiet={quiet} warmUp={warmUp} />
      <ExpectPage pageRef={refs.expect} host={host} address={address} cityName={cityName} T={T} low={low} high={high} city={city} />
      <ServicePage pageRef={refs.service} host={host} address={address} cityName={cityName} mgmtFee={mgmtFeePct} offer={OFFER} contact={CONTACT} netTotal={T.net} bedrooms={bedrooms} guests={guests} baseRate={baseRate} occupancy={T.occ} vatRate={vatRatePct} platformFee={platformFeePct} validTo={validTo} refCode={ref} />
    </div>
  );
}